<template>
    <div class="page-title">

        <div
            class="layout-width"
            style="padding: 10px 20px">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item
                    :to="{ path: '/' }">
                    Accueil
                </el-breadcrumb-item>
                <el-breadcrumb-item
                    v-if="parent"
                    :to="{ path: parent.path }">
                    {{ parent.text }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    {{ cBreadcrumb }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div
            :class="cClass"
            class="page-title-header">
            <div class="layout-width padding ">
                <h1>{{ text }}</h1>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: {
        text: {
            type: String,
            required: true
        },
        parent: {
            type: Object,
            default: () => {}
        },
        breadcrumb: {
            type: String,
            default: ''
        },
        css: {
            type: String,
            default: ''
        }
    },
    computed: {
        cClass () {
            return this.css ? 'page-title-header-' + this.css : '';
        },
        cBreadcrumb () {
            return this.breadcrumb ? this.breadcrumb : this.text;
        }
    }
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';
.page-title {
    display: block;

    .page-title-header {
        background: url('../../../../static/images/carto-view-large-background.jpg') no-repeat center center;
        background-size: cover;
        color: white;
        h1 {
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ui/PageTitle.vue